import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocalizationModule } from 'angular-l10n';
import { MaterialModule } from '../../common/material.module'

import { AppSidebarFilterComponent } from './app-sidebar-filter.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LocalizationModule,
    MaterialModule
  ],
  declarations: [AppSidebarFilterComponent],
  providers: [],
  exports: [
    AppSidebarFilterComponent,
    LocalizationModule
  ]
})
export class AppSidebarFilterModule { }



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-filter/app-sidebar-filter.module.ts